/**
 * @fileoverview Renders the average assessment grade of a leaf item as a "hand"
 * icon (the design's "finger"). Mirrors the project-level TrackerScore so the
 * visual language stays consistent across the app.
 */

import { Tooltip } from '@mantine/core'
import { IconHands } from 'components/Icons'

interface AssessmentScoreProps {
  readonly score: number | null
  readonly tooltip: string
}

const ICON_SIZE = 28
const ICON_COLOR = '#2D3748'

export function AssessmentScore({ score, tooltip }: AssessmentScoreProps) {
  if (score == null || score <= 0) return null
  return (
    <Tooltip label={tooltip} multiline width={260} withArrow position='top'>
      <div role='img' aria-label={tooltip} style={{ display: 'inline-flex' }}>
        <IconHands value={score} width={ICON_SIZE} height={ICON_SIZE} color={ICON_COLOR} />
      </div>
    </Tooltip>
  )
}
